import PatientsPage from '../../features/patients/pages/PatientsPage';
import ChatPageContainer from '../../containers/ChatPageContainer';
import AppointmentsPage from '../../features/appointments/pages/AppointmentsPage';
import AdminPage from '../../features/admin/pages/AdminPage';
import SuperAdminPage from '../../features/superAdmin/pages/SuperAdminPage';
import MyAccountPage from '../../components/MyAccount/MyAccountPage';
import TherapyDetailsPage from '../../features/therapies/pages/TherapyDetailsPage';
import TrainingPlanDetailsPage from '../../features/training-plan/pages/TrainingPlanDetailsPage';

export const appRoutes = [
  { path: 'patients', element: <PatientsPage /> },
  { path: 'messages', element: <ChatPageContainer /> },
  { path: 'appointments', element: <AppointmentsPage /> },
  { path: 'therapien/:therapyId', element: <TherapyDetailsPage /> },
  { path: 'therapien/:therapyId/trainingPlan/:trainingId?', element: <TrainingPlanDetailsPage /> },
  { path: 'admin', element: <AdminPage /> },
  { path: 'super-admin', element: <SuperAdminPage /> },
  { path: 'account', element: <MyAccountPage /> },
];
